// src/pages/PainelCliente/ResgatarPremio.js
// Resgate de um prêmio avulso (rota resgatar/:id), com cálculo de frete.
import React, { useEffect, useState } from "react";
import axios from "../../axiosConfig";
import { calcularPontosPremio, formatarPontos, getImagemUrl } from "../../utils/tikpontos";
import { useParams, useNavigate } from "react-router-dom";
import "./ResgatarPremio.css";

function ResgatarPremio() {
  const { id } = useParams();
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  const [premio, setPremio] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [pontos, setPontos] = useState({ pontos_totais: 0, pontos_reservados: 0, pontos_disponiveis: 0 });
  const [valorPonto, setValorPonto] = useState(0.03);
  const [valorKm, setValorKm] = useState(1.2);
  const [freteEmPontos, setFreteEmPontos] = useState(null);
  const [valorKg, setValorKg] = useState(2.5);
  const [valorM3, setValorM3] = useState(350);
  const [empresaCep, setEmpresaCep] = useState(null);
  const navigate = useNavigate();
  const FALLBACK_CEP_EMPRESA = "01001-000";

  useEffect(() => {
    const carregarDados = async () => {
      try {
        const [resPremio, resPontos, resValor, resKm, resKg, resM3] = await Promise.all([
          axios.get(`/premios/${id}`),
          axios.get(`/clientes/${usuario.id}/pontos`),
          axios.get("/configuracoes/valor-ponto"),
          axios.get("/configuracoes/valor-por-km"),
          axios.get("/configuracoes/valor-por-kg"),
          axios.get("/configuracoes/valor-por-m3"),
        ]);
  
        setPremio(resPremio.data);
        setPontos(resPontos.data);
        setValorPonto(resValor.data.valor || 0.03);
        setValorKm(resKm.data.valor || 1.2);
        setValorKg(resKg.data.valor || 2.5);
        setValorM3(resM3.data.valor || 350);
  
        
        // Buscar o CEP da empresa com base no CNPJ
const resEmpresa = await axios.get("/empresas", {
  params: { cnpj: usuario.cnpj_empresa }
});
const empresa = resEmpresa.data.dados.find(e => e.cnpj === usuario.cnpj_empresa);
setEmpresaCep(empresa?.cep || FALLBACK_CEP_EMPRESA);


      } catch (err) {
        console.error("Erro ao carregar dados:", err);
        setMensagem("Erro ao carregar informações do prêmio.");
      }
    };
  
    carregarDados();
  }, [id, usuario.id]);
  

  useEffect(() => {
    const calcularFrete = async () => {
      if (!empresaCep || !usuario?.cep || !premio) return;
  
      if (premio.frete_gratis) {
        setFreteEmPontos(0);
        return;
      }
  
      try {
        const res = await axios.get("/calcular-distancia", {
          params: { cep_origem: empresaCep, cep_destino: usuario.cep }
        });
  
        const distanciaKm = res.data.distancia_km || 10;
  
        const peso = parseFloat(premio.peso_kg) || 0;
        const comprimento = parseFloat(premio.comprimento_cm) || 0;
        const largura = parseFloat(premio.largura_cm) || 0;
        const altura = parseFloat(premio.altura_cm) || 0;
        const volumeM3 = (comprimento * largura * altura) / 1000000;
  
        const freteReais =
          distanciaKm * valorKm +
          peso * valorKg +
          volumeM3 * valorM3;
  
        const pts = Math.ceil(freteReais / valorPonto);
        setFreteEmPontos(pts);
      } catch (err) {
        console.error("Erro ao calcular frete:", err);
        setFreteEmPontos(null);
      }
    };
  
    calcularFrete();
  }, [empresaCep, usuario?.cep, valorKm, valorKg, valorM3, valorPonto, premio]);
  
  const handleResgatar = async () => {
    try {
      await axios.post("/resgates", {
        usuario_id: usuario.id,
        premio_id: id
      });
      setMensagem("🎉 Resgate solicitado com sucesso! Aguarde a aprovação.");
      setTimeout(() => navigate("/painel-cliente"), 3000);
    } catch (error) {
      console.error("Erro ao solicitar resgate:", error);
      setMensagem(
        `❌ ${error?.response?.data?.error || "Erro ao solicitar resgate."}`
      );
    }
  };

  if (!premio) return <p>Carregando...</p>;

  // Antes esta função ficava fora do componente e usava valorPonto sem acesso
  // a ele (erro quando o prêmio não tinha valor_em_pontos).
  const pontosProduto = calcularPontosPremio(premio, valorPonto);
  const total = freteEmPontos !== null ? pontosProduto + freteEmPontos : pontosProduto;
  const saldoFinal = pontos.pontos_disponiveis - total;
  const podeResgatar = saldoFinal >= 0;

  return (
    <div className="resgate-container">
      {premio.imagem && (
        <div className="resgate-foto">
          <img src={getImagemUrl(premio.imagem)} alt={premio.nome || "Prêmio"} />
        </div>
      )}

      <div className="resgate-info">
        <h2>{premio.nome}</h2>

        <p><strong>Pontos do prêmio:</strong> {formatarPontos(pontosProduto)} pts</p>

        {freteEmPontos === 0 ? (
          <p style={{ color: "green", fontWeight: "bold" }}>🚚 Frete grátis</p>
        ) : freteEmPontos != null ? (
          <p><strong>Frete estimado:</strong> {freteEmPontos.toLocaleString("pt-BR")} pts</p>
        ) : (
          <p>Calculando frete...</p>
        )}

        <hr />

        <p><strong>Total necessário:</strong> {total.toLocaleString("pt-BR")} pts</p>
        <p><strong>Pontos disponíveis:</strong> {pontos.pontos_disponiveis.toLocaleString("pt-BR")} pts</p>
        <p><strong>Saldo após resgate:</strong> {saldoFinal < 0 ? 0 : saldoFinal.toLocaleString("pt-BR")} pts</p>

        <button 
          onClick={handleResgatar} 
          className="btn azul"
          disabled={!podeResgatar || freteEmPontos === null}
        >
          Confirmar Resgate
        </button>

        {mensagem && <p className="resgate-msg">{mensagem}</p>}
        {!podeResgatar && (
          <p className="resgate-erro">❌ Você não possui pontos suficientes para este resgate.</p>
        )}

        <button className="btn voltar" onClick={() => navigate("/painel-cliente")}>← Voltar</button>
      </div>
    </div>
  );
}

export default ResgatarPremio;
